import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import DealerLocator from './Components/DealerLocator.js';

const root = createRoot(document.getElementById('REACT_dealerLocator'));
root.render(
  <Sentry.ErrorBoundary>
    <DealerLocator {...window.dealerLocator} />
  </Sentry.ErrorBoundary>
);
